import React from "react";

const Intro = ({ toggleStart }) => {
  const startBtn = () => {
    console.log("start button");
    toggleStart();
  };

  return (
      <div className="intro_div">
          <h3>DIRECTIONS</h3>
          <p>
              This is not a test, so there are no wrong answers. The Spiritual Gifts
              Survey consists of 80 statements. Some items reflect concrete actions;
              others are descriptive traits; still others are statements of belief.
          </p>

          <p>
              Select the one response you feel best characterizes yourself and place
              that number in the blank provided. Record your answer in the blank
              beside each item.
          </p>

          <p>
              Do not spend too much time on any one item. Remember, it is not a test.
              Usually your immediate response is best.
          </p>
          <p>Please give an answer for each item. Do not skip any items.</p>

          <button className="start_butt" onClick={startBtn}>
              Click to Start
          </button>

          <p className={"intro_choices-title"}>Your response choices are:</p>
          <ul className="intro_instructions">
              <li className="vote five">
                  5—Highly characteristic of me/definitely true for me
              </li>
              <li className="vote four">
                  4—Most of the time this would describe me/be true for me
              </li>
              <li className="vote three">
                  3—Frequently characteristic of me/true for me–about 50 percent of the
                  time
              </li>
              <li className="vote two">
                  2—Occasionally characteristic of me/true for me–about 25 percent of
                  the time
              </li>
              <li className="vote one">
                  1—Not at all characteristic of me/definitely untrue for me
              </li>
          </ul>
          <hr></hr>
      </div>
  );
};

export default Intro;
